angular.module('v3sWbtPlayerApp').factory('v3sSliderElement', ["v3sExerciseElement", "v3sExerciseService", function (v3sExerciseElement, v3sExerciseService) {

     var v3sSliderElement = function (id) {
        this.id = id
        this.completed = false;
        this.correctAnswer = new Array();   // Zielwert für Handler
        this.userAnswer = new Array();      // Aktueller Wert
        this.moved = new Array();           // bewegte Handler
        this.aktCorrect = new Array();      // Korrekte Handler
        this.tooltip = false;
        this.tolerance = null;
        this.handelID = null;
        this.load();
    };

    v3sSliderElement.prototype = new v3sExerciseElement();

    v3sSliderElement.prototype.setCorrectAnswer = function (ca) {
        this.correctAnswer = ca;
    };

    v3sSliderElement.prototype.reverseArray = function () {
        var ra = this.correctAnswer.reverse();
        this.setCorrectAnswer(ra);
    };

    v3sSliderElement.prototype.getCorrectAnswer = function (nr) {
        return parseFloat(this.correctAnswer[nr]);
    };

    v3sSliderElement.prototype.isAnswerCorrect = function (nr) {
        return this.aktCorrect[nr];
    };

    v3sSliderElement.prototype.setAnswerTolerance = function (tolerance) {
        this.tolerance = parseFloat(tolerance);
    };

    v3sSliderElement.prototype.getHandlerLength = function () {
        return (this.correctAnswer.length);
    };

    v3sSliderElement.prototype.setCompleted = function () {
        this.completed = true;
    }

    v3sSliderElement.prototype.showTooltip = function () {
        return this.tooltip;
    }

    v3sSliderElement.prototype.setHandleID = function (nr) {
        this.handelID = parseInt(nr);
    }

    v3sSliderElement.prototype.getHandleID = function () {
        return this.handelID;
    }

    v3sSliderElement.prototype.checkAnswer = function (hid) {
        var antagonist = hid ? 0 : 1,               // id des nicht gezogenen Handlers
            zahlHandler = this.getHandlerLength(),
            aktAnswer = parseFloat(this.userAnswer[hid]),
            correctAnswer = this.getCorrectAnswer(hid),
            cMin = parseFloat(correctAnswer - this.tolerance),
            cMax = parseFloat(correctAnswer + this.tolerance),
            richtig = false;

        // Ist der aktuelle Handler korrekt?
        if (aktAnswer >= cMin && aktAnswer <= cMax) {
            this.aktCorrect[hid] = true;
        } else {
            this.aktCorrect[hid] = false;
        }

        //  ========================================================
        //  Auswerten, es sei denn:
        //  Antagonist ist (1) falsch und (2) nicht bewegt!!
        //  ========================================================
        if (zahlHandler === 2) {
            if (!this.aktCorrect[antagonist] && !this.moved[antagonist]) {
                // Nicht auswerten, also raus:
                return false;
            } else {
                //  Auswerten, also den Bewegungsarray rücksetzen:
                this.moved = [];
                // Alles richtig?
                if (this.aktCorrect[antagonist] && this.aktCorrect[hid]) {
                    richtig = true;
                }
            }
        } else {
            richtig = this.aktCorrect[hid];
        }

        //  ========================================================
        //  Auswerten
        if (richtig) {
            if (this.status != this.STATUS.CORRECT) {
                this.status = this.STATUS.CORRECT;
            }
        } else {
            this.status = this.STATUS.FALSE;
        }
        this.tooltip = true;

        //v3sExerciseService.checkExercise(this);
        this.save();

    }

    //  Auswertung:
    v3sSliderElement.prototype.setUserAnswer = function (answer, id) {
        if (answer === this.userAnswer) return;
        var hid = id;
        this.userAnswer =answer;
        this.moved[hid] = true;  // Merken, welcher Handler bewegt wurde
        this.checkAnswer(hid);

    };

    return v3sSliderElement;

}]);